import { ADVERTISING_OPT_IN_THRESHOLD } from "../constants/misc";
import { HAS_SEEN_ADVERTISING_PAGE } from "../constants/user_attributes";
import { CampaignItemStateAwaitingAudio, CampaignItemStateSent } from "../constants/campaigns";
import moment from "moment";

export const displayAdvertisingNotification = (show, user, campaignItemsReducerState) => {
  const campaignItemsForShow = (
    campaignItemsReducerState?.showCampaignItemUUIDs?.[show.uuid] ?? []
  ).map(itemUUID => campaignItemsReducerState.campaignItemByUUID[itemUUID]);
  const hasAudioDueSoon = campaignItemsForShow.some(item => {
    return (
      item.state === CampaignItemStateAwaitingAudio &&
      moment()
        .add(5, "d")
        .isAfter(moment.unix(item.uploadAudioBy))
    );
  });
  const hasPendingAds = campaignItemsForShow.some(item => item.state === CampaignItemStateSent);
  if (hasPendingAds || hasAudioDueSoon) {
    return true;
  }

  const hasEnoughDownloads = show.estimatedWeeklyDownloads > ADVERTISING_OPT_IN_THRESHOLD;
  const hasNotSetupAdvertisement = !show.advertisementSettings;
  const hasSeenAdvertisementForShow = (user?.userAttributes?.[HAS_SEEN_ADVERTISING_PAGE] ?? "")
    .split(",")
    .includes(show.uuid);
  return hasEnoughDownloads && hasNotSetupAdvertisement && !hasSeenAdvertisementForShow;
};
